// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/water-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/water-equipment/extended-over-water-operation.js';
import g1 from '../lessons/air-law/water-equipment/life-rafts-over-water.js';
import g2 from '../lessons/air-law/water-equipment/water-equipment.js';

mount([g0, g1, g2]);
